import { Fragment, ReactElement } from 'react';
import PersonSearchCivilUnionNonResidentNotificationCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-civil-union-non-resident/edit-person-search';
import { IdAmbito } from 'shell/constants/id-ambito';

const PersonSearchCivilUnionNonResidentNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <PersonSearchCivilUnionNonResidentNotificationCivilStatusShared
        scope={IdAmbito.Cancellazioni}
      />
    </Fragment>
  );
};

PersonSearchCivilUnionNonResidentNotificationCivilStatusPage.displayName =
  'Research CivilUnion Non Resident Notifications Page component';

export default PersonSearchCivilUnionNonResidentNotificationCivilStatusPage;
